<template lang="pug">
  .returning
</template>
<script>

export default {
  name: "ReturningFriends",
  props: {
    userStatus: {
      type: String,
      required: true,
    },
  },
  mounted() {
    this.getReturningRewards();
  },
  methods: {
    getReturningRewards() {
      const ACTIVITY_KEY = "return-gift-godweb-84394";
      if (this.userStatus === "old") {
        // this.$api.returningService.acceptInvite(ACTIVITY_KEY, user_id).run();
        this.$api.returnGiftService.getRewards(ACTIVITY_KEY, "ru").run();
      }
    },
  },
};
</script>
